import $ from 'jquery';
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {store} from '../../../store/store.js';
import {CommonUtil} from "../../../common/CommonUtil";
import LoginMask from '../../../components/loginmask.vue';
import {StorageUtil} from '../../../common/Auth.js';

export default {
  name: 'bookinfo',
  components: {
    LoginMask
  },
  data() {
      var libCode= this.$route.query.libCode || '';
    return {
      imgPath:imgPath,
      isbn: "",
      imgError: store.imgError,
      libCode:libCode,
      book: {currHallCodeExist:0},
      nav: [
        {
          name: '书籍信息',
          url: '/bookcontent?isbn=',
        },
        {
          name: '馆藏信息',
          url: '/bookinfo/libraryresource?libCode='+libCode+'&isbn=',
        }
      ],
      webType: store.webType, /*0:平台1：图书馆*/
      opacType:store.opacType,
      pageNo: 1,
      alertBoxFail: false,
      alertBoxSuccess: false,
      alertBoxSuccessMsg: "",
      alertBoxFailMsg: "",
      idCard: "",
      mag: '',
      errorCode: 0,
      totalPage: 1,
      readerId: store.user.readerId || '',
      appointStatus:true,   //是否预约
      statusBtn:1,  //0:不可预约，1:可预约，2:自己已预约
    }
  },
  beforeMount() {
    this.libCode = this.$route.query.hallCode || '';
    if(this.libCode===""){
      this.libCode = this.$route.query.libCode || '';
    }
    store.wrap.activeRouteName = '图书';
    this.isbn = this.$route.query.isbn;
    let url = api.book.info.replace('{isbn}', this.isbn).replace('{hallCode}',this.libCode);
    ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
      this.book = data;
      let shareArr=[];
      if(this.opacType == 0){
          shareArr=['weixin', 'sqq', 'qzone', 'tsina'];
          this.shareBtn(shareArr);
      }else{
          shareArr=['weixin'];
          this.shareBtn(shareArr);
      }

    }, null, this);
    //如果用户登录且馆号不为空
    if(store.user && this.libCode !=""){
      this.setReservations();
    }
  },
  beforeRouteLeave(to, from, next) {
    if($('#bdshare_weixin_qrcode_dialog')) {/*关闭分享组件微信分享页面*/
      $('#bdshare_weixin_qrcode_dialog').hide();
    }
    next()
  },
  methods: {
    //百度分享
    shareBtn(shareArr) {
      window._bd_share_config = {
        share: [{
          "tag": "share_book",
          "bdSize": 16,
          "bdCustomStyle": require('./sharebtn.sass')
        }],

        common: {
          bdText: '云图书馆' + ' - ' + this.book.bookName,
          bdDesc: this.book.summary?this.book.summary.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, ""):'',//去掉html标签和空格
          bdUrl: this.book.htmlUrl,
          bdPic:this.imgPath+this.book.image|| "../../../assets/noimg.png",
          bdMini: 1,
          bdMiniList: shareArr,
          bdPopupOffsetLeft: -73,
          bdPopupOffsetTop: 5,
        }
      }
    //   window._bd_share_main.init()
    },

    goback() {
      CommonUtil.getPrevList(this)
    },
    /**
     * 设置是否可预约
     * */
    setReservations() {
      console.log('设置是否可预约')
      var _this = this;
      var url = api.reservation.getAppointStaus.replace('{readerId}', this.readerId).replace('{libCode}', this.libCode).replace('{isbn}', this.isbn);
      ajaxUtil.ajaxJson(url, '', 'get', (data) => {
        _this.appointStatus = data.appointStatus;
        if(_this.appointStatus){
          this.statusBtn = 1
        }else{
          this.statusBtn = 2
        }
      }, null, this)
    },
    /**
     * 馆内预约
     */
    orderBook(){
      let idCard = store.func.getUserIdCard();
      if(!idCard) {
        this.$refs.loginMask.showLogin();
        return;
      }
      this.idCard = idCard;
      let appointRequestDto = {};
      appointRequestDto.appointType = 1;
      appointRequestDto.libCode = this.libCode;
      appointRequestDto.readerId = this.readerId;
      appointRequestDto.isbn = this.book.isbn;
      ajaxUtil.ajaxJson(api.reservation.appointByBackstage, appointRequestDto, "post", (data)=>{
        if (data.appointStatus == 0) {
          this.alertBoxSuccessMsg = "预约成功!";
        } else if (data.appointStatus == 1) {
            this.mag = "携带身份证";
            this.alertBoxSuccessMsg = "预约成功!";
        }
          this.alertBoxSuccess = true;
          this.statusBtn = 2;
      }, (data)=> {
          this.errorCode = data.errorCode;
          if(data.errorCode ===  2322){
              this.alertBoxFailMsg = "你已入本馆黑名单，被限制该业务操作！";
              this.alertBoxFail = true;
              this.statusBtn = 0;
          }else if (data.errorCode === 30301) {
            this.alertBoxFailMsg = "本书不支持外借！";
            this.alertBoxFail = true;
            this.statusBtn = 0;
        } else if (data.errorCode === 30202 ) {
            this.alertBoxFailMsg = "您在该图书馆无预约权限！";
            this.alertBoxFail = true;
            this.statusBtn = 0;
        } else if(data.errorCode === 30303 ){
            this.alertBoxFailMsg = "";
            this.alertBoxFail = true;
            this.statusBtn = 0;
        }else if(data.errorCode === 30100){
            this.alertBoxFail = false;
            this.statusBtn = 1;
        }else {
          this.alertBoxFailMsg = "暂无可预约书籍！";
          this.alertBoxFail = true;
          this.statusBtn = 0;
        }
      }, this);
    },
    //登录弹窗
    loginSuccess: function () {
      this.setReservations();
    },
    //关闭弹窗
    closeAlertBox() {
      this.alertBoxFail = false;
      this.alertBoxSuccess = false;
    },

    //查看预约
    checkAppointment(){
        this.$router.push({path: '/apply', query: {hallCode: this.libraryName}});
    },
  }
}

